import axios from 'axios';
import { API_BASE } from '../config';


const authHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`
  }
});

export const getClinicsAndPagesByProject = async (projectId) => {
  const res = await axios.get(`${API_BASE}clinics/project/${projectId}/tree`, authHeaders());
  return res.data;
};

export const getClinicsByProject2 = async (projectId) => {
  const res = await axios.get(
    `${API_BASE}clinics/project2/${projectId}`,
    authHeaders()
  );
  return res.data; // اینجا فقط آرایه‌ی کلینیک‌هاست
};


export const createClinic = async (data) => {
  try {
    const res = await axios.post(`${API_BASE}clinics`, data, authHeaders());
    return res.data;
  } catch (err) {
    console.error('خطا در ایجاد کلینیک:', err);
    throw new Error(err.response?.data?.message || 'ایجاد کلینیک با خطا مواجه شد.');
  }
};

// به‌روزرسانی کلینیک
export const updateClinic = async (id, data) => {
  try {
    const res = await axios.put(`${API_BASE}clinics/${id}`, data, authHeaders());
    return res.data;
  } catch (err) {
    console.error('خطا در ویرایش کلینیک:', err);
    throw new Error(err.response?.data?.message || 'ویرایش کلینیک با خطا مواجه شد.');
  }
};

// حذف کلینیک
export const deleteClinic = async (id) => {
  try {
    const res = await axios.delete(`${API_BASE}clinics/${id}`, authHeaders());
    return res.data;
  } catch (err) {
    console.error('خطا در حذف کلینیک:', err);
    throw new Error(err.response?.data?.message || 'حذف کلینیک با خطا مواجه شد.');
  }
};
